/**
 * Tonnie Languages Academy — what the citizen's Academy endpoints accept
 * (`/api/heroes/qultureup/academy`). The API validates with these; the World's
 * screens send them.
 */
import { z } from 'zod';
import { LANGUAGE_ACADEMY_LANGUAGES } from '@tonnie/types';

/** `POST /heroes/qultureup/academy/launch` — the language the citizen opens the school in. */
export const languageAcademyLaunchSchema = z.strictObject({
  learningLanguage: z.enum(LANGUAGE_ACADEMY_LANGUAGES),
});
export type LanguageAcademyLaunchInput = z.infer<typeof languageAcademyLaunchSchema>;

/**
 * `POST /heroes/qultureup/academy/consent` — the version of the consent text
 * the citizen read and accepted (the state's `consent.currentVersion`).
 */
export const languageAcademyConsentSchema = z.strictObject({
  textVersion: z.string().trim().min(1).max(40),
});
export type LanguageAcademyConsentInput = z.infer<typeof languageAcademyConsentSchema>;
